export default "__VITE_ASSET__C7q2g8rT__"